import { render, staticRenderFns } from "./recordWithdrawBig.vue?vue&type=template&id=cb1a2166&scoped=true"
import script from "./recordWithdrawBig.vue?vue&type=script&lang=js"
export * from "./recordWithdrawBig.vue?vue&type=script&lang=js"
import style0 from "./recordWithdrawBig.vue?vue&type=style&index=0&id=cb1a2166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a2166",
  null
  
)

export default component.exports